<template>
    <div class="goh-legacy-available-credits" v-if="isLimitedAccount">
        <p class="text"><span class="bold">{{ resolvedReleaseLimit - remainingReleases }}</span>/{{ resolvedReleaseLimit }} haakpatronen vrijgegeven deze maand</p>

        <goh-legacy-dot-bar
            :max="resolvedReleaseLimit" :value="resolvedReleaseCount"
            active-icon-class="icon--check ph-fill ph-check-circle"
            class="goh-legacy-dot-bar" inactive-icon-class="icon ph-duotone ph-circle"
        ></goh-legacy-dot-bar>
    </div>
</template>

<script>
import { Vue, Options } from "vue-class-component";
import { limitedAccountMixin } from '@gekophaken/common';

import LegacyDotBar from './LegacyDotBar.vue';


export default Options({
    name: 'goh-legacy-available-credits',
    mixins: [limitedAccountMixin],
    components: {
        [LegacyDotBar.name]: LegacyDotBar
    }
})(
    class LegacyAvailableCredits extends Vue {}
)

</script>
<style lang="scss">
.goh-legacy-available-credits {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem;
    background: rgb(0 0 0 / 3%);
    border: 1px solid rgb(0 0 0 / 5%);
    border-radius: 0.6rem;

    .text {
        font-size: 1.5rem;
        font-style: italic;

        .bold {
            font-weight: var(--ui-font-weight-bold);
        }
    }

    .goh-legacy-dot-bar {
        --goh-legacy-dot-bar-icon-size: 2.4rem;
        --goh-legacy-dot-bar-inactive-icon-color: var(--ui-color-primary-500);
    }
}
</style>
